import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}

import { computed } from "vue";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import Modal from "shared/components/modals/Modal.vue";
import { useHierarchyTags } from "shared/composables/hierarchyTags";
import { useProjectDurationSettings } from "shared/composables/projectDurationSettings";
import { PlanConfig } from "shared/types/Plan";
import { ShortenedProcessWithTags } from "shared/types/Process";
import ProjectProgressTable from "@/views/planner/components/ProjectProgressTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectProgressModal',
  props: {
    planConfig: {},
    processes: {},
    initialLocationFilters: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const { projectDurationSettings, isProjectDurationSettingsLoading } = useProjectDurationSettings();
const { hierarchyTags, isLoading: areHierarchyTagsLoading } = useHierarchyTags();

const isLoading = computed(
  () => isProjectDurationSettingsLoading.value || areHierarchyTagsLoading.value,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    open: true,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
    customCls: "w-full mx-auto overflow-hidden h-full"
  }, {
    content: _withCtx(() => [
      (!isLoading.value && _unref(projectDurationSettings))
        ? (_openBlock(), _createBlock(ProjectProgressTable, {
            key: 0,
            planConfig: _ctx.planConfig,
            processes: _ctx.processes,
            projectDurationSettings: _unref(projectDurationSettings),
            hierarchyTags: _unref(hierarchyTags),
            class: "overflow-auto h-full",
            showEvenWhenCompleted: true,
            initialLocationFilters: _ctx.initialLocationFilters
          }, null, 8, ["planConfig", "processes", "projectDurationSettings", "hierarchyTags", "initialLocationFilters"]))
        : _createCommentVNode("", true),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingSpinner)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})